(() => {
  const templates = {"5-days:art:1":"jb5-art","5-days:culture:1":"jb5-culture","5-days:family:1":"jb5-family","5-days:food:1":"jb5-food","5-days:gardens:1":"jb5-gardens","5-days:views:1":"jb5-views","7-days:art:1":"jb7-art","7-days:culture:1":"jb7-culture","7-days:family:1":"jb7-family","7-days:food:1":"jb7-food","7-days:gardens:1":"jb7-gardens","7-days:views:1":"jb7-views","3-hours:hutongs:1":"jbl-3h-hutongs-1","3-hours:hutongs:2":"jbl-3h-hutongs-2","3-hours:hutongs:3":"jbl-3h-hutongs-3","3-hours:culture:1":"jbl-3h-culture-1","3-hours:culture:2":"jbl-3h-culture-2","3-hours:culture:3":"jbl-3h-culture-3","3-hours:food:1":"jbl-3h-food-1","3-hours:food:2":"jbl-3h-food-2","3-hours:food:3":"jbl-3h-food-3","3-hours:views:1":"jbl-3h-views-1","3-hours:views:2":"jbl-3h-views-2","3-hours:views:3":"jbl-3h-views-3","3-hours:art:1":"jbl-3h-art-1","3-hours:art:2":"jbl-3h-art-2","3-hours:art:3":"jbl-3h-art-3","3-hours:night:1":"jbl-3h-night-1","3-hours:night:2":"jbl-3h-night-2","3-hours:night:3":"jbl-3h-night-3","1-day:hutongs:1":"jbl-1d-hutongs-1","1-day:hutongs:2":"jbl-1d-hutongs-2","1-day:hutongs:3":"jbl-1d-hutongs-3","1-day:culture:1":"jbl-1d-culture-1","1-day:culture:2":"jbl-1d-culture-2","1-day:culture:3":"jbl-1d-culture-3","1-day:food:1":"jbl-1d-food-1","1-day:food:2":"jbl-1d-food-2","1-day:food:3":"jbl-1d-food-3","1-day:views:1":"jbl-1d-views-1","1-day:views:2":"jbl-1d-views-2","1-day:views:3":"jbl-1d-views-3","1-day:art:1":"jbl-1d-art-1","1-day:art:2":"jbl-1d-art-2","1-day:art:3":"jbl-1d-art-3","1-day:night:1":"jbl-1d-night-1","1-day:night:2":"jbl-1d-night-2","1-day:night:3":"jbl-1d-night-3","2-days:culture:1":"jbl-2d-culture-1","2-days:culture:2":"jbl-2d-culture-2","2-days:culture:3":"jbl-2d-culture-3","2-days:hutongs:1":"jbl-2d-hutongs-1","2-days:food:1":"jbl-2d-food-1","2-days:art:1":"jbl-2d-art-1","2-days:family:1":"jbl-2d-family-1","2-days:views:1":"jbl-2d-views-1","2-days:views:2":"jbl-2d-views-2","3-days:culture:1":"jbl-3d-culture-1","4-days:culture:1":"jbl-4d-culture-1","3-days:gardens:1":"jbl-3d-gardens-1","4-days:gardens:1":"jbl-4d-gardens-1","3-days:food:1":"jbl-3d-food-1","4-days:food:1":"jbl-4d-food-1","3-days:art:1":"jbl-3d-art-1","4-days:art:1":"jbl-4d-art-1","3-days:family:1":"jbl-3d-family-1","4-days:family:1":"jbl-4d-family-1","3-days:views:1":"jbl-3d-views-1","4-days:views:1":"jbl-4d-views-1"};
  if (document.body.classList.contains('listing-page')) {
    const query = new URLSearchParams(location.search);
    const requestedId = query.get('route_id');
    const prefixes = { '3h': '3-hours', '1d': '1-day', '2d': '2-days', '3d': '3-days', '4d': '4-days' };
    const match = requestedId?.match(/^jb-(3h|[1-4]d)-([a-z]+)-(\d{2})$/);
    const routeKey = match ? [prefixes[match[1]], match[2], String(Number(match[3]))].join(':') : null;
    if (query.has('route_id') && !/^jb-(5|7)d-/.test(requestedId || '') &&
        (query.getAll('route_id').length !== 1 || !routeKey || !Object.hasOwn(templates, routeKey))) {
      document.body.replaceChildren();
      const message = document.createElement('main');
      const heading = document.createElement('h1');
      heading.textContent = 'Journey not found';
      message.append(heading);
      document.body.append(message);
      window.JBListingEditorRedirecting = true;
      return;
    }
    if (routeKey && Object.hasOwn(templates, routeKey)) {
      const [duration, series, journey] = routeKey.split(':');
      const target = new URL(location.href);
      target.searchParams.set('duration', duration);
      target.searchParams.set('series', series);
      target.searchParams.set('journey', journey);
      target.searchParams.set('view', templates[routeKey]);
      if (target.search !== location.search) {
        window.JBListingEditorRedirecting = true;
        location.replace(target.href);
        return;
      }
    }
    if (!document.querySelector('[data-jb-listing-editor]')) {
      const context = window.JB_ROUTE_CONTEXT || { duration: query.get('duration') || '3-hours', series: query.get('series') || 'hutongs', journey: query.get('journey') || '1' };
      const view = templates[[context.duration, context.series, context.journey].join(':')];
      if (view && query.get('view') !== view) {
        const target = new URL(location.href); target.searchParams.set('view', view);
        window.JBListingEditorRedirecting = true; location.replace(target.href); return;
      }
    }
  }
  const editor = Boolean(window.Shopify?.designMode);
  let root;
  let slots = [];
  let api;
  const cleanup = [];
  const media = source => {
    const value = source || '';
    return value.startsWith('asset:') ? window.JB_ROUTE_ASSETS?.[value.slice(6)] || window.JB_TWO_DAY_ASSETS?.[value.slice(6)] || window.JB_FIVE_DAY_ASSETS?.[value.slice(6)] || window.JB_SEVEN_DAY_ASSETS?.[value.slice(6)] || value : value;
  };
  const byType = type => slots.filter(slot => slot.type === type);
  const gallerySlots = () => byType('gallery_media').filter(slot => slot.src);
  const annotate = (node, slot) => {
    if (!node || !slot || !editor) return;
    node.setAttribute('data-jb-slot', slot.id);
    if (slot.attributes) node.setAttribute('data-shopify-editor-block', slot.attributes);
  };
  const replaceMedia = (node, slot) => {
    if (!node || !slot?.src) return;
    const source = media(slot.src);
    const next = document.createElement(source.startsWith('video:') ? 'video' : 'img');
    next.id = node.id;
    next.className = node.className;
    if (next.tagName === 'VIDEO') {
      next.src = source.slice(6); next.muted = true; next.autoplay = true; next.loop = true; next.playsInline = true; next.controls = true;
      next.setAttribute('aria-label', slot.alt || slot.title || '');
    } else {
      next.src = source; next.alt = slot.alt || slot.title || ''; next.loading = 'lazy'; next.decoding = 'async';
    }
    annotate(next, slot);
    node.replaceWith(next);
  };
  const text = (selector, value, slot) => root.querySelectorAll(selector).forEach(node => {
    if (value !== undefined && value !== null) {
      const arrow = node.matches('.listing-plan, .listing-reading-end a') ? node.querySelector('span')?.cloneNode(true) : null;
      const reference = selector === '#reading-source' ? node.querySelector('a')?.cloneNode(true) : null;
      node.textContent = value;
      if (arrow) node.append(arrow);
      if (reference) node.append(' ', reference);
    }
    annotate(node, slot);
  });
  const prepare = () => {
    root = document.querySelector('[data-jb-listing-editor]');
    if (!root) return false;
    slots = Array.from(root.querySelectorAll('[data-jb-slot-record]'), node => {
      const record = JSON.parse(node.querySelector('script[type="application/json"]').textContent);
      record.attributes = node.getAttribute('data-shopify-editor-block');
      return record;
    });
    const [duration, series, journey] = root.dataset.jbListingEditor.split(':');
    window.JB_ROUTE_CONTEXT = { duration, series, journey };
    const key = root.dataset.jbListingEditor;
    const detail = window.JB_LISTING_DETAILS[key];
    const category = window.JB_SERIES_CATEGORIES[duration + ':' + series] || window.JB_SERIES_CATEGORIES[series];
    const heading = byType('route_heading')[0];
    const item = category.listings[Number(journey) - 1];
    if (heading) { item[0] = heading.title; item[3] = heading.body; }
    const stops = byType('route_stop');
    detail.stops = stops.map(slot => [slot.title, slot.body, slot.src]);
    const reading = byType('reading_header')[0];
    if (reading) detail.intro = reading.body;
    byType('editorial_copy').forEach(slot => { detail[slot.target] = slot.body; });
    const credits = byType('photo_credits')[0];
    if (credits) detail.photoCredits = credits.body;
    const editorial = window.JB_ROUTE_EDITORIAL[key] || {};
    editorial.title = heading?.seo_title || `${item[0]} | Private Beijing Journey | Jingbound`;
    editorial.description = heading?.seo_description || item[3];
    editorial.faq = byType('faq_item').map(slot => `${slot.title} | ${slot.body}`).join('\n');
    if (credits) editorial.sources = credits.sources;
    const practical = byType('practical_copy');
    editorial.meeting = practical[2]?.body; editorial.walking = practical[3]?.body; editorial.bestFor = practical[4]?.body;
    window.JB_ROUTE_EDITORIAL[key] = editorial;
    const video = byType('journey_video')[0];
    const gallery = byType('gallery_media');
    window.JB_LISTING_MEDIA[key] = { ...window.JB_LISTING_MEDIA[key], subjects: stops.map(slot => slot.alt || slot.title).join('\n'), video: video?.src?.replace(/^video:/, '') || null, readingPhoto: gallery[0]?.src };
    return true;
  };
  const mediaChanged = (type, position) => {
    if (!root) return;
    const slot = (type === 'stop' ? byType('route_stop') : gallerySlots())[position];
    const node = document.getElementById(type === 'stop' ? 'route-focus-image' : 'reading-image');
    annotate(node, slot);
    if (type === 'stop') {
      annotate(root.querySelector('.route-focus-caption'), slot);
      if (node?.tagName === 'IMG' && slot?.alt) node.alt = slot.alt;
    }
  };
  const connect = callbacks => {
    if (!root) return;
    api = callbacks;
    const heading = byType('route_heading')[0];
    text('#listing-title', heading?.title, heading);
    text('#route-lede', heading?.lede, heading);
    const reading = byType('reading_header')[0];
    text('#reading-title', reading?.title, reading); text('#reading-kicker', reading?.kicker, reading); text('#reading-intro', reading?.body, reading);
    byType('route_stop').forEach((slot, i) => {
      annotate(root.querySelectorAll('#route-timeline li')[i], slot);
      annotate(root.querySelectorAll('#route-thumbs button')[i], slot);
    });
    gallerySlots().forEach((slot, i) => annotate(root.querySelectorAll('#reading-dots button')[i], slot));
    byType('editorial_copy').forEach(slot => {
      text('#reading-' + slot.target, slot.body, slot);
      text('#reading-' + slot.target + '-title', slot.title, slot);
      annotate(root.querySelector('#reading-' + slot.target)?.parentElement, slot);
    });
    const cards = root.querySelector('.listing-day-depth-cards');
    const chapters = byType('day_chapter');
    if (chapters.length) {
      cards.replaceChildren();
      chapters.forEach(slot => {
        const card = document.createElement('article');
        const copy = document.createElement('div'); copy.className = 'listing-day-copy';
        const title = document.createElement('small'); title.textContent = slot.title;
        const paragraph = document.createElement('p'); paragraph.textContent = slot.body;
        copy.append(title, paragraph); card.append(copy);
        if (slot.src) { const placeholder = document.createElement('img'); card.prepend(placeholder); replaceMedia(placeholder, slot); }
        annotate(card, slot); cards.append(card);
      });
      root.querySelector('#listing-day-depth').hidden = false;
    }
    byType('practical_copy').forEach((slot, i) => {
      const nodes = root.querySelectorAll('#listing-full-practical .listing-practical-cards section, #listing-full-practical .listing-practical-facts section');
      const node = nodes[i];
      if (node) { node.querySelector('h3').textContent = slot.title; node.querySelector('p').textContent = slot.body; annotate(node, slot); }
      const book = root.querySelectorAll('.journey-sheet-right .listing-practical-cards section, .journey-sheet-right .listing-practical-facts section')[i];
      if (book) { book.querySelector('h3').textContent = slot.title; book.querySelector('p').textContent = callbacks.shortCopy(slot.body, i < 2 ? 105 : 75); annotate(book, slot); }
    });
    const faq = root.querySelector('#listing-reading-faq');
    const bookFaq = root.querySelector('.journey-sheet-right .listing-faq');
    faq.replaceChildren(); bookFaq.querySelectorAll('.listing-faq-link, details').forEach(node => node.remove());
    byType('faq_item').forEach((slot, i) => {
      const detail = document.createElement('details'); detail.id = 'listing-answer-' + i; detail.open = i === 0;
      const question = document.createElement('summary'); question.textContent = slot.title;
      const answer = document.createElement('p'); answer.textContent = slot.body;
      detail.append(question, answer); annotate(detail, slot); faq.append(detail);
      if (i < 3) {
        const link = document.createElement('a'); link.className = 'listing-faq-link'; link.href = '#' + detail.id; link.textContent = slot.title + ' →';
        link.addEventListener('click', () => { detail.open = true; }); annotate(link, slot); bookFaq.append(link);
      }
    });
    const labels = byType('page_copy');
    labels.forEach(slot => {
      Object.entries(slot.copy || {}).forEach(([selector, value]) => text(selector, value, slot));
      (slot.areas || []).forEach(selector => root.querySelectorAll(selector).forEach(node => annotate(node, slot)));
    });
    const art = byType('book_media')[0];
    replaceMedia(root.querySelector('.journey-book-base'), art);
    const video = byType('journey_video')[0];
    let videoSection = root.querySelector('.listing-journey-video');
    if (!videoSection && editor) {
      videoSection = document.createElement('section'); videoSection.className = 'listing-journey-video jb-editor-video-empty';
      const title = document.createElement('h3'); title.textContent = video.title;
      const hint = document.createElement('p'); hint.textContent = '上传视频后显示；此提示仅在编辑器显示。';
      videoSection.append(title, hint); root.querySelector('#listing-day-depth').before(videoSection);
    }
    if (videoSection) { videoSection.querySelector('h3').textContent = video.title; annotate(videoSection, video); }
    const credits = byType('photo_credits')[0];
    annotate(root.querySelector('#listing-photo-credits'), credits);
    if (editor) { root.querySelectorAll('[data-jb-slot-record]').forEach(node => node.removeAttribute('data-shopify-editor-block')); }
    mediaChanged('stop', 0); mediaChanged('gallery', 0);
  };
  window.JBListingEditor = { prepare, connect, mediaChanged, gallery: () => gallerySlots().map(slot => ({ src: slot.src, label: slot.alt || slot.title })), cleanup: () => { cleanup.splice(0).forEach(fn => fn()); }, track: fn => cleanup.push(fn) };
  if (editor) {
    document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-jb-listing-editor]')) window.JBListingEditor.cleanup(); });
    document.addEventListener('shopify:section:load', event => {
      if (!event.target.querySelector('[data-jb-listing-editor]')) return;
      window.JBListingEditor.cleanup(); prepare(); window.JBInitializeDeepPages?.();
    });
    document.addEventListener('shopify:block:select', event => {
      const slot = slots.find(item => item.id === event.detail.blockId);
      if (!slot || !api) return;
      let target = root.querySelector('[data-jb-slot="' + CSS.escape(slot.id) + '"]');
      if (slot.type === 'route_stop') { api.showStop(byType('route_stop').indexOf(slot)); target = root.querySelector('.listing-route-focus'); }
      if (slot.type === 'gallery_media') { const index = gallerySlots().indexOf(slot); if (index >= 0) api.showGallery(index); target = root.querySelector('.listing-reading-image'); }
      if (slot.type === 'faq_item') { target = root.querySelector('#listing-answer-' + byType('faq_item').indexOf(slot)); target.open = true; }
      target?.scrollIntoView({ behavior: 'auto', block: 'center' });
    });
  }
})();